import styled from "styled-components"

import tick from "@irati/ui/images/tick.png"

export const StyledSignUpOption = styled.div`
  position: relative;
  display: inline-block;
  padding: 20px 20px 20px 50px;
  width: 75%;
  cursor: pointer;
  &:before {
    content: "";
    display: none;
    height: 30px;
    width: 30px;
    background-image: url(${tick});
    background-size: cover;
    position: absolute;
    left: 10px;
    top: 20px;
  }
  ${({active, theme}) =>
    active
      ? `
    cursor: default;
    &:before {
      display: block;
    }
  `
      : `
    opacity: 0.4;
    &:hover {
      opacity: 1;
      background-color: ${theme.colors.greys.graphGrey};
      color: ${theme.colors.greys.mediumDark};
      &:before {
        display: block;
        opacity: 0.3;
      }
    }`}
`

export const Content = styled.div`
  margin-top: 20px;
`
